import { render, staticRenderFns } from "./ReferFriendBox.vue?vue&type=template&id=1e35de3c&"
import script from "./ReferFriendBox.vue?vue&type=script&lang=ts&"
export * from "./ReferFriendBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports